import api from './api'

class CategoryService {
  static getCategoryBySlug(slug, filters) {
    return api
      .call('get', `/pages/category/${slug || 'all'}`, { params: filters })
      .then(api.getData)
  }
}

export default CategoryService
